// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"footer-component_uk-open__3TtSo","grecaptcha-badge":"footer-component_grecaptcha-badge__fxum2","footer":"footer-component_footer__mIVJr","footer__bottom":"footer-component_footer__bottom__2dxCS","footer__bottom-holder":"footer-component_footer__bottom-holder__lwPPp","footer__logo-box":"footer-component_footer__logo-box__khw6F","footer__logo":"footer-component_footer__logo__rHEa9","footer__nav":"footer-component_footer__nav__MC6Wv"};
    if(module.hot) {
      // 1752653728123
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  